export const galleryOptions = [
  {
    width: '100%',
    height: '100%',
    imageArrows: false,
    thumbnails: false,
    imagePercent: 100,
    previewFullscreen: true,
    previewCloseOnEsc: true,
    previewKeyboardNavigation: true,
    previewZoom: true,
    previewZoomMax: 5,
    previewZoomMin: 0.2
  }
];
